import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import {Pie} from 'react-chartjs-2';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import './AttributeSummary.css';

class AttributeSummary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chartData: this.props.chartData
    };
  }

  addSum = (total, num) => {
    return total + num;
  }

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

  render()
  {
    var tableRows = [];
    let data = this.state.chartData;
    let totalCount = data.datasets[0].data.reduce(this.addSum);
    let totalAcresCount = data.datasets[0].acres.reduce(this.addSum);

    for (var i = 0; i < data.labels.length; i++)
    {
      tableRows.push(
        <TableRow key={i}>
        <TableCell component="th" scope="row">
          {data.labels[i]}
        </TableCell>
        <TableCell align="right">{data.datasets[0].data[i]}</TableCell>
        <TableCell align="right">{parseFloat((data.datasets[0].data[i] / totalCount * 100)).toFixed(2) + " %"}</TableCell>
        <TableCell align="right">{this.numberWithCommas(parseFloat((data.datasets[0].acres[i])).toFixed(2))}</TableCell>
      </TableRow>
    )
    }

    tableRows.push(
    <TableRow key='totalCountRow'>
      <TableCell component="th" scope="row" style={{fontWeight:"bold"}}>Total</TableCell>
      <TableCell align="right" style={{fontWeight:"bold"}}>{totalCount}</TableCell>
      <TableCell align="right"></TableCell>
      <TableCell align="right"style={{fontWeight:"bold"}}>{this.numberWithCommas(parseFloat(totalAcresCount).toFixed(2))}</TableCell>
    </TableRow>
  );

    return (
        <Paper>
        <div className="row">
           <div className="summaryColumn">
           <Table size="small">
           <TableHead>
             <TableRow>
               <TableCell>{this.props.label}</TableCell>
               <TableCell align="right">Number of Incidents</TableCell>
               <TableCell align="right">Percentage</TableCell>
               <TableCell align="right">Acres</TableCell>
             </TableRow>
           </TableHead>
           <TableBody>
          {tableRows}
           </TableBody>
         </Table>
           </div>
           <div className="summaryColumn">
            <Pie data={this.state.chartData} width={400} height={400} />
           </div>
        </div>
       </Paper>
    )
  }
}

export default AttributeSummary
